export default {
  namespaced: true,
  state: {
    jobsDescs: {},
    userJobs: [],
  },
  mutations: {
    SET_JOBS_DESCS(state, jobsDescs) {
      const jobsDescWithIdAsKey = {};
      jobsDescs.forEach( job => {
        jobsDescWithIdAsKey[job.id] = job;
      }
      );
      state.jobsDescs = jobsDescWithIdAsKey;
    },
    SET_USER_JOBS(state, userJobs) {
      state.userJobs = userJobs;
    }
  },
  getters: {
    userJobs(state){
      return state.userJobs;
    },

    getPostByIndex: (state) => (postIndex) => {
      if (state.userJobs[postIndex]) {
        if (state.userJobs[postIndex].number>0){
          const jobId = state.userJobs[postIndex].template_id;

          if (state.jobsDescs[jobId]) {
            return state.jobsDescs[jobId];
          }
        }
      }
    }
  }
};
